import React, { lazy, Suspense } from "react";
import DefaultLoader from "../utilities/loaders/DefaultLoader";
const MembershipDirectoryContent = lazy(
    () => import("./MembershipDirectoryContent"),
);

const MembershipDirectory = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <MembershipDirectoryContent />
        </Suspense>
    );
};

export default MembershipDirectory;
